export default __webpack_public_path__ + "static/media/5100.6addf58f.png";